import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MdContact from './components/externalContact/mdContact';
import ScContact from './components/externalContact/scContact';
import ScInternalContact from './components/internalContact/scInternalContact';
import reportWebVitals from './reportWebVitals';
import MdInternalContact from './components/internalContact/mdInternalContact';
import WSI from './components/wsi/weeklySafetyInspections';
import SF from './components/safetyForm/safetyForms';
import SafetyPolicy from './components/safetyPolicies/safetyPolicy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <SF/> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
